import { AppMobile, getFromLocalStorageByKey } from '@vfit/shared/data-access';
export interface IAppItem {
  encryptedValue: string;
  planType: string;
  type: 'sim' | 'landline';
  value: string;
}
export interface IAppSession {
  username: string;
  firstname: string;
  email: string;
  fiscalcode: string;
  status: string;
  installationId: string;
  type_sim: string;
  osVersion: string;
  profile: string;
  appVersion: string;
  appPlatform: string;
  value: string;
  type: string;
  sessionId: string;
  mid: string;
  secretKey: string;
  token: string;
  customerUserAgent: string;
  pbo: string;
  isOverlay: boolean;
  isNext: boolean;
  role: string;
  contactId: string;
  customerId: string;
  items?: IAppItem[];
}

const getUrlExtension = (url: string): string =>
  url?.split(/[#?]/)?.[0]?.split('.')?.pop()?.trim() || '';

export const isValidURL = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export const linkInAppOpener = (link: string, target?: '_blank' | '_self' | '_parent' | '_top') => {
  const appSession = getFromLocalStorageByKey('appSession');
  if (appSession) AppMobile.openInBrowser(link);
  else window.open(link, target ? target : '_blank');
};

export const downloadFileFunction = (url: string) => {
  const urlExt = getUrlExtension(url);
  const isPdf = urlExt === 'pdf';

  const openLink = (link: string) => {
    const isApp = AppMobile.checkIsApp();
    const appSession: IAppSession = getFromLocalStorageByKey('appSession');
    if (isApp && appSession) {
      AppMobile.openInBrowser(link);
    } else {
      window.open(link, '_blank');
    }
  };

  if (!isPdf) {
    openLink(url);
  } else {
    openLink(url);
    // fetch(url, {
    //   method: 'GET',
    // })
    //   .then((resp) => resp.blob())
    //   .then((blob) => {
    //     const urlLocal = window.URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.style.display = 'none';
    //     a.href = urlLocal;
    //     a.download = name;
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(urlLocal);
    //   });
  }
};

const allowedDomains = ['vodafone.it', 'vodafone.com'];

export const isValidSecureUrl = (url: string, isDev?: boolean) => {
  if (isDev) return true;

  const decodedUrl = decodeURIComponent(url);
  try {
    const parsed = new URL(decodedUrl);

    if (parsed.protocol !== 'https:') return false;
    if (parsed.username || parsed.password) return false;

    const hostname = parsed.hostname.toLowerCase();

    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '::1' ||
      /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
      /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
      /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)
    ) {
      return false;
    }

    if (allowedDomains?.length > 0) {
      const isAllowed = allowedDomains.some((allowed: string) => {
        const regex = new RegExp(
          `^([a-z0-9]+(-[a-z0-9]+)*\\.)*${allowed.replace('.', '\\.')}$`,
          'i'
        );
        return regex.test(hostname);
      });
      if (!isAllowed) return false;
    }

    return true;
  } catch {
    return false;
  }
};

